import { rankWith, scopeEndsWith } from "@jsonforms/core";

export default rankWith(4, scopeEndsWith("owner"));
